<mat-button-toggle-group class="st-manage-publication-channels-main-cta-button-group">
    <mat-button-toggle
        class="st-manage-publication-channels-main-cta-button-new-channel"
        (click)="openNewChannelDialog()">
        <mat-icon class="material-symbols-outlined">add</mat-icon>
        {{ languageSettings.PSTWebNPCHLabel }}
    </mat-button-toggle>
</mat-button-toggle-group>
